import React from "react";
import { ImageObject } from "@shared/Map/types";
import { ToolCanvas } from "@shared/Map/tools/PathTool";

interface ShapeToolProps {
	toolCanvas: ToolCanvas;
	onAdd: (newObject: ImageObject) => void;
}

const ImageTool: React.FC<ShapeToolProps> = (props) => {
	return (
		<>
			<rect
				x={props.toolCanvas.x}
				y={props.toolCanvas.y}
				width={props.toolCanvas.width}
				height={props.toolCanvas.height}
				fill={"#ffffff00"}
			/>
		</>
	);
};

export { ImageTool };
